export const equipmentLifecycle = (equipment) =>
  equipment?.lifecycle_status || "active";

export const isOperationalEquipment = (equipment) =>
  equipmentLifecycle(equipment) === "active";
